import React from "react";
import {useTranslation} from "react-i18next";
import EventTemplateCategory from "../../../stores/domainStore/pages/models/eventTemplateCategory";
import ButtonIcon from "../../atoms/button/buttonIcon";
import EventTemplateCard from "../../atoms/eventTemplateCard/eventTemplateCard";
import "./eventTemplateList.sass";

export interface IEventTemplateListProps {
  /**
   * Event template category to be displayed.
   */
  eventTemplateCategory: EventTemplateCategory;
  /**
   * Show the "See all" option
   */
  showSeeAll: boolean;
  /**
   * A function to call when use template button is clicked.
   */
  onUseTemplate: (id: string) => void;
  /**
   * A function to call when the user wishes to see all the templates in the template category.
   */
  onSelectTemplateCategory: (id: string) => void;
}

const EventTemplateList: React.FC<IEventTemplateListProps> = ({
  eventTemplateCategory,
  showSeeAll,
  onUseTemplate,
  onSelectTemplateCategory
}) => {
  const {t} = useTranslation(["translation", "eventTemplate"]);

  const templateCards = eventTemplateCategory.eventTemplates.map((template) => (
    <EventTemplateCard
      key={template.id}
      imageSrc={template.image}
      description={template.description}
      imageId={template.imageId}
      title={template.title}
      onClick={onUseTemplate}
      templateId={template.id}
      isNew={template.isNew}
    />
  ));

  return (
    <>
      <div className="event-template-list">
        <div className="category-title">
          <div>{eventTemplateCategory.name}</div>
          {showSeeAll && (
            <ButtonIcon
              type="inline"
              onClick={() => onSelectTemplateCategory(eventTemplateCategory.id)}
            >
              {t("eventTemplate:labels.seeAll")}
            </ButtonIcon>
          )}
        </div>
        <div className="template-cards">{templateCards}</div>
      </div>
    </>
  );
};

export default EventTemplateList;
